// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"0c513c0e24fbd78a6fcf","966":"530da309ab8cea301079"}[chunkId] + ".js";
};